module.exports = __webpack_public_path__ + "img/f9887a9.jpg";